<template>
<article-layout>
    <div class="subpage-top">
        <h1>In de media</h1>
        <router-link to="/#media">Terug</router-link>
    </div>
    <plattelands></plattelands>
    <defile></defile>
</article-layout>
</template>

<script>
import ArticleLayout from "./ArticleLayout";
import Defile from "../Media/Defile";
import Plattelands from "../Media/Plattelands";
export default {
    name: "MediaDetailed",
    components: {
        ArticleLayout,
        Defile,
        Plattelands
    },
    
}
</script>

<style scoped>
</style>

